import { Client } from './client';
import { CENTRAL_AUTH_URL, UI_VERSION } from 'helpers/config/environment';
import { IntegrationType } from 'helpers/integration/IntegrationType';


export class ClientFactory {
    public static createClient(tenantId: string, integrationType: IntegrationType, sessionHeaders: { [key: string]: unknown }): Client {
        return new Client(CENTRAL_AUTH_URL, UI_VERSION, tenantId, integrationType, sessionHeaders);
    }
}
